<template>
  <span
    class="base-inline-text-source"
    :class="{ ai: method === 'LLM_EXTRACTION', manual: method === 'PDF_ANNOTATION', compact }"
  >
    <SmallLogo
      v-if="method === 'LLM_EXTRACTION'"
      class="base-inline-text-source__icon"
      v-tooltip="$t('evaluation-grid.view-extraction')"
    />
    <BaseIcon
      v-else-if="method === 'PDF_ANNOTATION'"
      name="link"
      class="base-inline-text-source__icon"
      v-tooltip="$t('evaluation-grid.view-extraction')"
    />
    <span v-if="documentId && !compact" class="__document-name">{{ getFileName(documentId) }}</span>
  </span>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import SmallLogo from '@/assets/images/aloha-logomark-mono.svg';

import { mapGetters } from 'vuex';

export default {
  name: 'BaseInlineTextSource',
  components: {
    BaseIcon,
    SmallLogo,
  },
  props: {
    method: {
      type: String,
      required: false,
      default: '',
    },
    compact: {
      type: Boolean,
      default: false,
    },
    documentId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('opportunity', ['opportunity']),
  },
  methods: {
    getFileName(documentId) {
      const document = this.opportunity.documents.find((doc) => doc.id === documentId);
      if (!document) {
        return '';
      }

      return document.name;
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.base-inline-text-source {
  cursor: pointer;
  background: $color-neutral;
  padding: 4px 8px;
  width: max-content;
  height: max-content;
  border-radius: 32px;
  display: inline-flex;
  align-items: center;
  vertical-align: baseline;

  &.compact {
    padding: 4px;
  }

  &__icon {
    color: $color-accent;
    width: 12px;
    height: 12px;
  }

  &.ai {
    @include action-preset-hooks('soft', 'ai');
    background: var(--action-bg);
    transition: all 200ms ease;

    &:hover {
      background: var(--action-bg-hover);
      transition: all 200ms ease;
    }

    .base-inline-text-source__icon {
      color: var(--action-text);
    }
  }

  &.manual {
    background: rgba($color-text-annotation, 0.6);
    transition: all 200ms ease;

    &:hover {
      transition: all 200ms ease;
      background: rgba($color-text-annotation, 1);
    }
  }

  .__document-name {
    margin-left: 4px;
    font-size: 12px;
    color: $color-normal;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
    white-space: nowrap;
    flex: 1 1 auto;
  }
}
</style>
